import PhoneFlagText from './PhoneFlagText';

export default PhoneFlagText;
